import { TYPE } from '@kontentino/kontentino-constants/Pages';
import { Dayjs } from 'dayjs';
import { DropEffect } from 'types/dnd';

export enum PseudoPostType {
  Unknown = 'unknown',
  Ad = 'ad',
  Status = 'status',
  Link = 'link',
  Carousel = 'carousel',
  Story = 'story',
  Gallery = 'gallery',
  Video = 'video',
  Photo = 'photo',
  Event = 'event',
  Offer = 'offer',
  Reel = 'reel',
  PhotoGallery = 'photoGallery',
  Document = 'document',
}

export enum PostExportVariant {
  Images = 1,
  Txt,
  Pdf,
  Csv,
  ExternalLink,
}

export const X_POST_TEXT_MAX_CHAR_LIMIT_FREE = 280;
export const X_POST_TEXT_MAX_CHAR_LIMIT_PREMIUM = 25000;

export const PostTextMaxCharLimit: Record<number, number> = {
  [TYPE.INSTAGRAM]: 2200,
  [TYPE.LINKEDIN]: 3000,
  [TYPE.PINTEREST]: 500,
  [TYPE.TWITTER]: X_POST_TEXT_MAX_CHAR_LIMIT_FREE,
  [TYPE.GOOGLE_MY_BUSINESS]: 1500,
  [TYPE.YOUTUBE]: 5000,
  [TYPE.TIKTOK]: 4000,
  [TYPE.THREADS]: 500,
};

export function getPostTextMaxCharLimit(page: {
  type: number;
  xHasLongPostSupport?: boolean | null;
}): number {
  if (page.type === TYPE.TWITTER && page.xHasLongPostSupport) {
    return X_POST_TEXT_MAX_CHAR_LIMIT_PREMIUM;
  }

  return PostTextMaxCharLimit[page.type];
}

export type PostDndDropItem = {
  postId: number;
};

export type PostDndDropResult = {
  area?: PostDndDropType;
  dropEffect: DropEffect;
  date?: Dayjs;
  postId?: number;
};

export enum PostDndDragType {
  CalendarPostCard = 'CalendarPostCard',
  GridPostCard = 'GridPostCard',
  SidePanelPost = 'SidePanelPost',
  CalendarInspirationCard = 'CalendarInspirationCard',
  SidePanelInspiration = 'SidePanelInspiration',
}

export type DragInspirationItem = {
  inspirationId: number;
  pageId: number;
  date: string;
  text: string;
  isRecurring: boolean;
};

export enum PostDndDropType {
  CalendarDateDay = 'CalendarDateDay',
  PostsSidePanelIdeas = 'PostsSidePanelIdeas',
  MoveDropArea = 'MoveDropArea',
  DuplicateDropArea = 'DuplicateDropArea',
  GridPostCard = 'GridPostCard',
  PostsSidePanelInspirationToPost = 'PostsSidePanelInspirationToPost',
  PostsSidePanelInspirationToIdea = 'PostsSidePanelInspirationToIdea',
}
